import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
import * as i2 from "../config/app.config";
export class ConfigService {
    constructor(http, environment) {
        this.http = http;
        this.environment = environment;
        this.configDirPath = 'config/';
        this.envFile = 'env.json';
        this.config = null;
        this.env = null;
    }
    getConfig(key) {
        return this.config[key];
    }
    init() {
        return new Promise((resolve, reject) => {
            this.http
                .get(`${this.configDirPath}${this.envFile}`)
                .pipe(map((res) => {
                return res.json();
            }), catchError((error) => {
                console.log(`Configuration file '${this.configDirPath}${this.envFile}' could not be read`);
                resolve(true);
                // tslint:disable-next-line: deprecation
                return Observable.throw(error.json().error || 'Server error');
            }))
                .subscribe((envResponse) => {
                this.env = envResponse;
                let request = null;
                switch (envResponse.env) {
                    case 'prod':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'qa':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'tst':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'dev':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'local':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'sbx':
                        {
                            request = this.http.get(`${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`);
                        }
                        break;
                    case 'default':
                        {
                            console.error('Environment file is not set or invalid');
                            resolve(true);
                        }
                        break;
                }
                if (request) {
                    request
                        .pipe(map((res) => {
                        return res.json();
                    }), catchError((error) => {
                        console.error(`Error reading '${envResponse.env}' configuration file.`);
                        resolve(error);
                        // tslint:disable-next-line: deprecation
                        return Observable.throw(error.json().error || 'Server error.');
                    }))
                        .subscribe(responseData => {
                        this.config = responseData;
                        //console.log(`[CONFIG] Loaded config.${envResponse.env}.json:`, responseData);
                        resolve(true);
                    });
                }
                else {
                    console.error('Env config file "env.json" is not valid.');
                    resolve(true);
                }
            });
        });
    }
    sendClientID() {
        return this.clientID;
    }
}
ConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(i0.ɵɵinject(i1.Http), i0.ɵɵinject(i2.AppConfig)); }, token: ConfigService, providedIn: "root" });
